"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var resource_1 = require("../shared/resource");
var camelcaseKeysDeep = require('camelcase-keys-deep');
var TripDecision = /** @class */ (function (_super) {
    __extends(TripDecision, _super);
    function TripDecision() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    TripDecision.prototype.url = function (action) {
        return '/trips/' + this.id + '/decisions/' + action;
    };
    TripDecision.prototype.filterOptions = function (options) {
        options = lodash_1.clone(options);
        return options;
    };
    return TripDecision;
}(resource_1.Resource));
exports.TripDecision = TripDecision;
